export default {"src":"/_next/static/media/runway-ml.43c8523a.svg","height":512,"width":512};